export { default as GenInternalLink } from './GenInternalLink';
